import { connect } from 'react-redux';
import { getStreamId } from '../../../../CommentThread/helpers';
import { getCommentableTypeForDeviationType } from '../../../../DeviationPage/redux/helpers';
import { openCommentsThread } from '../../redux/actions';
import { getIsCommentsThreadInFeedOpen } from '../../redux/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    var commentableTypeId = getCommentableTypeForDeviationType(deviation.typeId);
    var commentStreamId = getStreamId(commentableTypeId, deviation.deviationId);
    return {
        commentsVisible: getIsCommentsThreadInFeedOpen(state, commentStreamId),
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var deviation = _a.deviation;
    var commentableTypeId = getCommentableTypeForDeviationType(deviation.typeId);
    var commentStreamId = getStreamId(commentableTypeId, deviation.deviationId);
    return {
        showComments: function () { return dispatch(openCommentsThread(commentStreamId)); },
    };
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CardLayout.container.js.map